import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import TopicCard from "@/components/base/TopicCard";
import Reveal from "@/components/base/Reveal";

export default function FeaturedTopics() {
  const featured = topics.slice(2, 8);

  return (
    <section id="featured" className="border-y border-background-200/60 bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <span className="flex items-center gap-2 text-xs tracking-[0.3em] text-secondary-500">
                <i className="ri-bookmark-3-line" />
                EDITOR PICK
              </span>
              <h2 className="heading-serif mt-3 text-2xl font-black text-foreground-950 md:text-3xl">
                精选瓜田 · 值得慢慢看的长讨论
              </h2>
              <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-500">
                这些话题的讨论区里，信息量比情绪多。适合泡一杯茶，把评论区从头翻到尾。
              </p>
            </div>
            <Link
              to="/topics"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300/70 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:border-secondary-500 hover:text-secondary-500"
            >
              浏览话题广场
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((topic, index) => (
            <Reveal key={topic.id} delay={index * 50}>
              <TopicCard topic={topic} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}